import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=4e2149e4&scoped=true&"
import script from "./InfoSection.vue?vue&type=script&lang=js&"
export * from "./InfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=4e2149e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2149e4",
  null
  
)

export default component.exports